import { IHttpService, IQService, module } from 'angular';
import {
  Application,
  ApplicationDataSourceRegistry,
  SETTINGS,
} from '@spinnaker/core';

export const SLA_DATASOURCE = 'spinnaker.sla.datasource';
const ngmodule = module(SLA_DATASOURCE, []);
ngmodule.run((
  $q: IQService,
  $http: IHttpService,
) => {
  'ngInject';

  // Swap between pointing at platform and lighthouse, depending on the
  // setting of armoryPlatformEnabled.
  const loadSLAEndpoint = (appName: string) => {
    if (SETTINGS.feature.armoryPlatformEnabled) {
      return SETTINGS.gateUrl + '/platform/v1/sla/apps/' + appName;
    }
    return SETTINGS.gateUrl + '/armory/v1/sla/' + appName
  }

  // Platform uses a token in the url to authenticate, while lighthouse
  // uses normal Spinnaker auth cause it runs through Gate. If we try to
  // pass Gate credentials to platform it errors out, so we also need to
  // swap the http request config along with the endpoint.
  const loadSLAConfig = () => {
    if (SETTINGS.feature.armoryPlatformEnabled) {
      return {}
    }
    return {withCredentials: true}
  }

  const loadSLA = (application: Application) => {
    return $http.get(loadSLAEndpoint(application.name), loadSLAConfig())
    .then((resp) => {
      const sla: number = (<any>resp.data)['sla'];
      if (sla || sla === 0) {
        return Number(sla).toFixed(1) + '%';
      } else {
        const err: string = (<any>resp.data)['error'];
        if (err) {
          return '!';
        }
      }
      return 'N/A';
    });
  };

  const slaLoaded = (_application: Application, sla: string) => {
    // Existing framework expects an array of elements, but we want
    // to just return a string to be displayed, so we fake out
    // the methods called on the data

    const fakeArrayForSLAInfoIcon = {
      length: parseFloat(sla),
      filter: function() {
        return fakeArrayForSLAInfoIcon;
      },
      map: function() {
        return fakeArrayForSLAInfoIcon;
      }
    };

    return $q.when(fakeArrayForSLAInfoIcon);
  };


  // so linter doesn't complain
  if (SETTINGS.feature.slaEnabled) {
    ApplicationDataSourceRegistry.registerDataSource({
      defaultData: {}, // TODO what should this be?
      key: 'sla',
      sref: '.sla',
      onLoad: slaLoaded,
      lazy: true,
      primary: true,
      icon: 'fa fa-sm fa-fw fa-chart-bar sla-label',
      badge: 'currentSLA',
    });

    ApplicationDataSourceRegistry.registerDataSource({
      defaultData: {}, // TODO what should this be?
      key: 'currentSLA',
      visible: false,
      loader: loadSLA,
      onLoad: slaLoaded,
    });
  }

});

